var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayTimeStamp)?_c('div',{staticClass:"kai-time-stamp"},[_c('div',{staticClass:"brand-profile-name"},[_c('span',{staticClass:"kai-quick-timestamp"},[_vm._v(_vm._s(_vm.processTimeStamp))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }